module.exports = __webpack_public_path__ + "img/1454982434.40e4400a.jpg";